import { UserClaim } from "../../../../Wrap/Constants/Enums/UserClaim";
import { SingleDataStore } from "../../Stores/SingleDataStore";
import { SingleDataStoreDispacher } from "../../Stores/SingleDataStoreDispacher";

export const PermissionDisaptcher: SingleDataStoreDispacher<Array<UserClaim>> = new SingleDataStoreDispacher<
    Array<UserClaim>
>();
export const PermissionStore: SingleDataStore<Array<UserClaim>> = new SingleDataStore<Array<UserClaim>>(
    PermissionDisaptcher
);
